import { Guid } from "guid-typescript";
import { isArray } from "lodash";

/**
 * @description modify remit details by using Id
 * @param {Array<any>} remitDetails - Remit details records
 * @returns {Array<any>}
 */
export const addIdsToRecords = (records:Array<any>): Array<any> => {
  try{
    if(isArray(records) && records.length > 0){
        return records.map((record) => ({
        ...record,
        id: Guid.create().toString()
      }));
    }else{
      return []
    }   
  }catch(error)
  {
     return [];
  }
}
